module.exports = __webpack_public_path__ + "static/img/logo-black.b719202e.png";